<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="primary" class="chaxun">查询</Button>
      </div>
    </div>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="nodeName">
        <a @click="openNode(row)">{{ row.nodeName }}</a>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openChuli(row)">处理</Button>
        <Button size="small" @click="openBackFormFun(row)">退回</Button>
        <Button size="small" @click="openJincheng(row)">进程</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <Modal v-model="openForm" title="请按照以下步骤处理" footer-hide width="1000">
      <div style="height: calc(100% - 50px);overflow-y: auto;overflow-x: hidden;">
        <dataDetail ref="dataDetail">
          <ul slot="passengers">
            <li v-for="(x, index) in passengers" :key="index">
              {{ x.name }}/{{ x.tel }}
            </li>
          </ul>
          <table style="width: 100%;" slot="endcontent">
            <thead>
              <tr>
                <td>签字员</td>
                <td>签字时间</td>
                <td>图片</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(t, index) in signList" :key="index">
                <td>{{ t.name }}</td>
                <td>{{ utils.time(t.time, 'yymmdd') }}</td>
                <td>
                  <imgList :data="t.fileList"></imgList>
                </td>
              </tr>
            </tbody>
          </table>
        </dataDetail>
      </div>
      <div style="margin-top: 10px;">
        <Button v-for="(y, index1) in steps[1].btns" :key="index1" type="success" @click="clickBtn(y, index1)"
          style="margin-right: 6px">{{ y.name }}</Button>
        <Button @click="openFlowFun" type="primary" v-show="!hideSummitBtn">流程提交</Button>
      </div>
    </Modal>
    <Modal v-model="openFlowForm" :title="isFinish ? '流程办结' : '流程提交给下一处理人'" footer-hide width="700">
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="90">
        <Row :gutter="16">
          <Col span="12">
          <FormItem label="当前节点" prop="nodeName">
            <Input v-model="item.nodeName" readonly placeholder="请输入"></Input>
          </FormItem>
          </Col>
          <Col span="12" v-if="!isFinish">
          <FormItem label="下个节点" prop="nextNodeName">
            <Input v-model="item.nextNodeName" readonly placeholder="请输入"></Input>
          </FormItem>
          </Col>
          <Col span="12" v-if="!isFinish">
          <FormItem label="待办人" prop="auditorUser1">
            <Select :filterable="true" v-model="item.auditorUser1" @on-change="selectUser" :multiple="false">
              <Option v-for="(x, index) in users" :key="index" :label="x.name" :value="x.accountId"></Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="处理意见" prop="content">
            <Input v-model="item.content" placeholder="请输入"></Input>
          </FormItem>
          </Col>
          <Col span="24">
          <FormItem v-show="false" label="处理图片" prop="afterImgList">
            <ly-photo ref="lyphoto" v-model="item.afterImgList"></ly-photo>
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="chuli('item')">提交处理</Button>
          </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <Modal v-model="openBackForm" title="退回处理" footer-hide width="400" height="400">
      <Form ref="backItem" :model="backItem" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
          <FormItem label="处理意见" prop="content">
            <Input v-model="backItem.content" placeholder="请输入"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="backNode('backItem')">提交处理</Button>
          </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <jincheng ref="jincheng"></jincheng>
    <qianzi ref="qianzi" @ok="reOk"></qianzi>
    <feiyongqianzi ref="feiyongqianzi" @ok="reOk"></feiyongqianzi>
    <nowNoName ref="nowNoName"></nowNoName>
    <paichepaisiji ref="paichepaisiji" @ok="reOk"></paichepaisiji>
    <endTask ref="jieshu" @ok="reOk"></endTask>
  </div>
</template>
<script>
import jincheng from "./jincheng.vue";
import docDetail from "./docDetail.vue";
import rule from "./forms/rule";
import qianzi from "./qianzi.vue";
import feiyongqianzi from "./feiyongqianzi.vue";
import nowNoName from "./nowNoName.vue";
import paichepaisiji from "./diaoduNew/diaodu.vue";
import endTask from "./endTask.vue";
import fields from "./forms/fields"
export default {
  components: {
    jincheng,
    docDetail,
    qianzi,
    nowNoName,
    paichepaisiji,
    endTask,
    feiyongqianzi
  },
  data() {
    return {
      openForm: false,
      openBackForm: false,
      openFlowForm: false,
      value: "2",
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "工单号",
          key: "title",
        },
        {
          title: "流程名称",
          key: "flowName",
        },
        {
          title: "当前节点",
          slot: "nodeName",
        },
        {
          title: "提交人",
          key: "addUser",
        },
        {
          title: "提交意见",
          key: "remark",
        },
        {
          title: "状态标签",
          key: "stateLable",
        },
        {
          title: "派车标记",
          key: "label",
        },
        {
          title: "待办人",
          key: "auditorUser",
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        flowStartId: "", //流程实例ID
        nodeId: "", //当前节点ID
        nodeName: "",
        nextNodeId: "", //下个节点id
        nextNodeName: "",
        auditorUserid: [], //处理用户账号列表
        auditorUser: [],
        content: "",
        beforeImg: "",
        beforeImgList: [],
        afterImg: "",
        afterImgList: [],
        filePath: "",
      },
      backItem: {
        flowStartId: "",
        content: "",
      },
      banjieItem: {
        flowStartId: "",
        content: "",
        beforeImg: "",
        afterImg: "",
        filePath: "",
      },

      ruleValidate: {
        name: { required: true, message: "必填" },
        content: { required: true, message: "必填" },
      },
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startDate: 0,
        endDate: 0,
      },
      total: 0,
      categorys: [],
      isFinish: false,
      selectItems: [],
      steps: [
        {
          name: "审阅材料",
          btns: [],
          icon: "md-eye",
        },
        {
          name: "填写材料",
          btns: [],
          icon: "ios-open",
        },
        {
          name: "流程处理",
          btns: [
            {
              name: "现在处理",
              type: "flow",
            },
          ],
          icon: "md-checkmark-circle",
        },
      ],
      current: 2,
      users: [],
      signList: [],
      passengers: [],
      hideSummitBtn:false
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/pendingList",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].nextNodeId = "";
          data[i].nextNodeName = "";
          data[i].beforeImg = "";
          data[i].beforeImgList = [];
          data[i].afterImg = "";
          data[i].afterImgList = [];
          data[i].content = "同意";
        }
        this.tableData = data;
        //console.log(777888,data)
      });
      
    },

    openChuli(row) {
      this.openForm = true;
      if (row.formId == '11') {
        row.formId = 'yongcheshenqing';
      }
      console.log(row);
      this.item = row;
      this.current = 0;
      this.getNextNode(3);
      this.getDetail();
    },
    //获取详情
    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + fields[this.item.formId + 1],
        data: { id: this.item.docId }
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;
        //console.log(3333,data);
        this.detailChuli(data);
      });
    },
    //对详情进行处理
    detailChuli(data) {
      if (this.item.formId == 'yongcheshenqing') {
        this.passengers = data.passengers;
        data.planStartTime2 = this.utils.time(data.planStartTime);
        data.planEndTime2 = this.utils.time(data.planEndTime);
        data.planReachTime2 = this.utils.time(
          data.planReachTime,
          "yymmddhhmm"
        );
      }
      if (this.item.formId == 'baoyang') {
      }
      if (this.item.formId == 'weixiu') {
        data.repairDate2 = this.utils.time(data.repairDate, 'yymmdd')
      }
      this.signList = data.signList;

      this.$refs.dataDetail.reach(data, [{ title: '工单号', key: 'no' }, ...fields[this.item.formId]]);
    },
    chuli(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.item.beforeImg = this.item.beforeImgList.join(",");
          this.item.afterImg = this.item.afterImgList.join(",");
          if (this.isFinish) {
            this.axios({
              method: "post",
              url: this.axios.flow + "/flow/finish",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openFlowForm = false;
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            this.axios({
              method: "post",
              url: this.axios.flow + "/flow/nextProcess",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openFlowForm = false;
                this.openForm = false;
                this.getList();
              }
            });
          }
        } else {
          return 123;
        }
      });
    },
    check(name) {
      this.cc = false;
      this.$refs[name].validate((valid) => {
        this.cc = valid;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    getNextNode(type) {
      this.isFinish = false;
      ///cloud-common-server-flow/flow/nextNode
      this.utils.loading(this, "加载中");
      var can = {
        flowId: this.item.flowId,
        nodeId: this.item.nodeId,
        nodeType: type ? type : 1, //0-开始节点(新建时指定),1-中间节点,2-结束节点
      };
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/nextNode",
        data: can,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        console.log(data);
        
        if (type == 3) {
          this.hideSummitBtn=false;
          this.openRecordForm = true;
          var rule123 = data.rule;
          var m = rule123.split(",");

          if (this.utils.isEmpty(rule123)) {
            rule123 = "empty";
          }

          this.steps[1].btns.length = 0;
          for (let i = 0; i < m.length; i++) {
            
            if (m[i]=='paichepaisiji') {
              this.hideSummitBtn=true;
            }
            var rr = rule[m[i]];
            if (rr.name) {
              this.steps[1].btns.push(rr);
            }
          }
        } else {
          this.openForm = true;
          this.item.nextNodeId = data.id;
          this.item.nextNodeName = data.name;
          this.item.auditorUserid = [];
          this.item.auditorUser = [];
          var rule123 = data.rule;

          if (rule123 == "banzuzhang" && rule[rule123].autoSelectUser) {
            var aaa = this.$refs.docDetail.readItem();
            var obj = {
              accountId: aaa.workerId,
              name: aaa.workerLeader,
            };
            this.users = [obj];
            this.item.auditorUserid.push(aaa.workerId);
            this.item.auditorUser.push(aaa.workerLeader);
          } else {
            this.users = data.user;
            if (this.users.length == 1) {
              this.item.auditorUserid = [this.users[0].accountId];
              this.item.auditorUser = [this.users[0].name];
            }
          }
          this.item.auditorUser1 = this.item.auditorUserid[0];

          if (data.id == "E002") {
            this.isFinish = true;
          }
        }
      });
    },
    selectUser(x) {
      console.log(x);
      //this.item.auditorUserid = [x.value];
      //this.item.auditorUser = [x.label];
      var users = this.users, t = this.flowItem.auditorUser1;

      var a = [], b = [];
      for (let i = 0; i < users.length; i++) {
        for (let j = 0; j < t.length; j++) {
          if (users[i].accountId == t[j]) {
            a.push(users[i].accountId);
            b.push(users[i].name);
          }
        }
      }
      this.item.auditorUserid = a;
      this.item.auditorUser = b;
    },
    openBackFormFun(row) {
      this.openBackForm = true;
      this.backItem.flowStartId = row.flowStartId;
    },
    backNode() {
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/backProcess",
        data: this.backItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        if (res) {
          this.openBackForm = false;
          this.getList();
        }
      });
    },
    openFlowFun() {
      this.openFlowForm = true;
      this.getNextNode();
    },
    openJincheng(row) {
      this.$refs.jincheng.reach(row);
    },
    clickBtn(y, index) {
      this.isLastBtn = false;
      if (this.steps[1].btns.length - 1 == index) {
        this.isLastBtn = true;
      };
      var obj = {
        docId: this.item.docId,
        name: y.name || 111,
        key: y.key || 222,
        type: y.type || 333,
        title: this.item.title,
        nodeName: this.item.nodeName,
        formId: this.item.formId,
      };
      if (y.type == "mainForm") {
        this.$refs.docDetail.reach(this.item);
      } else if (y.type == "flow") {
        this.openFlowForm = true;
        this.getNextNode();
      } else if (y.type == "table") {
        this.$refs[y.key + "List"].reach(obj);
      } else {
        this.$refs[y.key].reach(obj);
      }
    },
    openNode(v) {
      this.$refs.nowNoName.reach(v);
    },
    reOk() {
      this.$refs.docDetail.reach(this.item);
      if (this.isLastBtn) {
        this.openFlowFun();
      }
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/diaodu/daibanchuli.vue